import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-primary mt-2 mb-0"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_6 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_7 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_8 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_9 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_10 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_11 = {
  key: 2,
  class: "ma-0"
}
const _hoisted_12 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_13 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_14 = {
  key: 2,
  class: "ma-0"
}
const _hoisted_15 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_16 = {
  key: 1,
  class: "ma-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fill: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "mb-2",
        style: {"height":"calc(100vh - 160px)","overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_back, {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.backPath()), ["stop"]))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-2 pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex align-center col-auto pr-3"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Régularisations de fin d'année des lignes avec montants >= 100 € HT ")
                    ])),
                    _: 1
                  }),
                  (_ctx.acrStatus && _ctx.acrStatus === 'UNKNOWN')
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "1",
                        class: "d-flex justify-end align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" $oss-circle-check ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (!_ctx.acrStatus || _ctx.acrStatus !== 'TO_UPDATE')
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "1",
                          class: "d-flex justify-end"
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.notCivilPeriodMessage)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.notCivilPeriodMessage), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  (_ctx.acrStatus && _ctx.acrStatus === 'TO_UPDATE')
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        class: "d-flex justify-start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            style: {"color":"red"},
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode(" $oss-warning ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.acrUpdatedMessage)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "11",
                        style: {"color":"red"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.acrUpdatedMessage), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.previousClosedApMessage)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 text-red" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.previousClosedApMessage), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (
                                _ctx.adjustments &&
                                _ctx.adjustments.type &&
                                _ctx.adjustments.lines &&
                                _ctx.adjustments.lines.length
                            )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments.lines, (line) => {
                              return (_openBlock(), _createElementBlock("div", {
                                "no-gutters": "",
                                key: line.id
                              }, [
                                _createVNode(_component_v_card, {
                                  class: "default_card_wm mx-auto py-2 mb-2",
                                  style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, {
                                      "primary-title": "",
                                      class: "py-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "mb-0 mt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              class: "pb-2 pr-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  modelValue: line.netAmount,
                                                  "onUpdate:modelValue": ($event: any) => ((line.netAmount) = $event),
                                                  "persistent-hint": "",
                                                  label: "Base HT",
                                                  "hide-details": "",
                                                  disabled: ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              class: "pb-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                (line.netAmount)
                                                  ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                      key: 0,
                                                      modelValue: line.adjustment.netAmount,
                                                      "onUpdate:modelValue": [
                                                        ($event: any) => ((line.adjustment.netAmount) = $event),
                                                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAdjustmentsChange()))
                                                      ],
                                                      disabled: _ctx.disabledTextFields,
                                                      persistentHint: true,
                                                      label: 'HT à régulariser',
                                                      hideDetails: true,
                                                      rules: [
                                                        (v) =>
                                                            v <= line.netAmount ||
                                                            'Valeur maximale ' + [line.netAmount],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ]
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "rules"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "mb-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              class: "pb-2 pr-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                        line.vatRate &&
                                                        typeof line.vatRate === 'number'
                                                    )
                                                  ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                      key: 0,
                                                      disabled: _ctx.disabledTextFields,
                                                      modelValue: line.vatRate,
                                                      "onUpdate:modelValue": ($event: any) => ((line.vatRate) = $event),
                                                      "persistent-hint": "",
                                                      label: "TVA %",
                                                      "hide-details": ""
                                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                                                  : (
                                                        line.vatRate &&
                                                        typeof line.vatRate != 'number'
                                                    )
                                                    ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                        key: 1,
                                                        disabled: _ctx.disabledTextFields,
                                                        modelValue: line.vatRate,
                                                        "onUpdate:modelValue": ($event: any) => ((line.vatRate) = $event),
                                                        "persistent-hint": "",
                                                        label: "TVA %",
                                                        "hide-details": ""
                                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_2, "Pas de taux de TVA"))
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              class: "pb-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                (line.vatAmount)
                                                  ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                                      key: 0,
                                                      disabled: _ctx.disabledTextFields,
                                                      modelValue: line.vatAmount,
                                                      "onUpdate:modelValue": ($event: any) => ((line.vatAmount) = $event),
                                                      "persistent-hint": "",
                                                      label: "TVA",
                                                      "hide-details": ""
                                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_3, "Pas de TVA"))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "mt-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              class: "pb-2 pr-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  "hide-details": true,
                                                  label: "DU",
                                                  textFieldReadOnly: false,
                                                  formatDate: 'DD/MM/YYYY',
                                                  minDate: _ctx.minDate,
                                                  modelValue: line.adjustment.startDate,
                                                  "onUpdate:modelValue": [
                                                    ($event: any) => ((line.adjustment.startDate) = $event),
                                                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAdjustmentsChange()))
                                                  ],
                                                  disabled: _ctx.disabledTextFields,
                                                  error: 
                                                        _ctx.getDatePickerError(
                                                            line.adjustment.startDate,
                                                            line.adjustment.endDate,
                                                        )
                                                    
                                                }, null, 8, ["minDate", "modelValue", "onUpdate:modelValue", "disabled", "error"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              class: "pb-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  "hide-details": true,
                                                  label: "AU",
                                                  textFieldReadOnly: false,
                                                  formatDate: 'DD/MM/YYYY',
                                                  minDate: _ctx.minDate,
                                                  modelValue: line.adjustment.endDate,
                                                  "onUpdate:modelValue": [
                                                    ($event: any) => ((line.adjustment.endDate) = $event),
                                                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAdjustmentsChange()))
                                                  ],
                                                  disabled: _ctx.disabledTextFields,
                                                  error: 
                                                        _ctx.getDatePickerError(
                                                            line.adjustment.startDate,
                                                            line.adjustment.endDate,
                                                        )
                                                    
                                                }, null, 8, ["minDate", "modelValue", "onUpdate:modelValue", "disabled", "error"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "mb-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                        line.adjustment &&
                                                        line.adjustment.totalDaysLength &&
                                                        ((line.adjustment.previousPeriod &&
                                                            line.adjustment.previousPeriod
                                                                .partialAmountSigned) ||
                                                            (line.adjustment.nextPeriod &&
                                                                line.adjustment.nextPeriod
                                                                    .partialAmountSigned))
                                                    )
                                                  ? (_openBlock(), _createElementBlock("b", _hoisted_4, "Total " + _toDisplayString(line.adjustment.totalDaysLength) + " jrs", 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                (line.adjustment.status === 'TO_UPDATE')
                                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                                      key: 0,
                                                      style: {"color":"red"},
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                        _createTextVNode(" $oss-warning ")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              class: "pb-2",
                                              cols: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                        line.accountableAccount &&
                                                        line.accountableAccount.name
                                                    )
                                                  ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                      key: 0,
                                                      label: "Compte",
                                                      "hide-details": "",
                                                      readonly: "",
                                                      disabled: "",
                                                      "model-value": line.accountableAccount.name
                                                    }, null, 8, ["model-value"]))
                                                  : (line.accountableAccount)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                        key: 1,
                                                        label: "Compte",
                                                        "hide-details": "",
                                                        readonly: "",
                                                        disabled: "",
                                                        "model-value": 
                                                        _ctx.getDisplayName(line.accountableAccount)
                                                    
                                                      }, null, 8, ["model-value"]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.periods, (period, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "ma-0 pa-0"
                                          }, [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    (line.adjustment[period].textTemplate)
                                                      ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(line.adjustment[period].textTemplate), 1))
                                                      : (_openBlock(), _createElementBlock("h4", _hoisted_6))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  class: "text-left",
                                                  cols: "2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (line.adjustment[period].dateDiff)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(line.adjustment[period].dateDiff) + " jrs ", 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_8))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, {
                                                  class: "text-right",
                                                  cols: "4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (
                                                            line.adjustment[period]
                                                                .partialAmountSigned &&
                                                            line.adjustment[period]
                                                                .partialAmountSigned > 0
                                                        )
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                line.adjustment[period]
                                                                    .partialAmountSigned,
                                                                undefined,
                                                            )) + " HT ", 1))
                                                      : (
                                                            line.adjustment[period]
                                                                .partialAmountSigned &&
                                                            line.adjustment[period]
                                                                .partialAmountSigned < 0
                                                        )
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(-line.adjustment[period]
                                                                .partialAmountSigned) + " HT ", 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_11, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (period === 'previousPeriod')
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      class: "text-right",
                                                      cols: "2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (line.vatRate)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(line.vatRate) + " % ", 1))
                                                          : (line.vatRate === null)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Libre "))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_14, "0 %"))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      class: "text-right",
                                                      cols: "2"
                                                    }, {
                                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                        _createTextVNode("-")
                                                      ])),
                                                      _: 1
                                                    })),
                                                (period === 'previousPeriod')
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 2,
                                                      class: "text-right",
                                                      cols: "4"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                            line.adjustment[period].vatAmountSigned
                                                        )
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    line.adjustment[period]
                                                                        .vatAmountSigned,
                                                                ),
                                                                undefined,
                                                            )) + " TVA ", 1))
                                                          : (_openBlock(), _createElementBlock("p", _hoisted_16, "0 TVA"))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 3,
                                                      class: "text-right",
                                                      cols: "2"
                                                    }, {
                                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                        _createTextVNode("-")
                                                      ])),
                                                      _: 1
                                                    }))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128)),
                            (_ctx.removedLinesMessage && _ctx.removedLinesMessage.length)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  class: "default_card_wm mx-auto py-2",
                                  style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, {
                                      "primary-title": "",
                                      class: "py-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "pb-2 pr-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  style: {"color":"red"},
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                    _createTextVNode(" $oss-warning ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "pb-2 pr-2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.removedLinesMessage), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.disabledValidateBtn)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            "no-gutters": "",
                            class: "my-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "auto",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createAdjustments())),
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                      _createTextVNode(" Générer ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.auditCheckResult && _ctx.auditCheckResult.id)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "auto",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                            class: "mx-1",
                                            color: "primary"
                                          }), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list, null, {
                                            default: _withCtx(() => [
                                              (_ctx.auditCheckResult && _ctx.auditCheckResult.id)
                                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: 0,
                                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.auditCheckResult.id)))
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { size: "small" }, {
                                                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                          _createTextVNode(" $oss-trash ")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                          _createTextVNode(" Supprimer les régularisations du document ")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.headerMessage)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 2,
                    "no-gutters": "",
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 text-red" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.headerMessage), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}